import React, { useMemo } from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { paymentPlanCategoryType } from '~constants';

const useStyles = makeStyles(theme => ({
  container: {
    padding: '20px 24px 10px 24px',
    backgroundColor: theme.colors.gray2,
    border: `1px solid ${theme.colors.borderColor}`,
  },
  section: {
    display: 'flex',
    marginBottom: 10,
  },
  labelArea: {
    width: 257,
  },
  valueArea: {
    flex: 1,
    paddingLeft: 24,
    overflow: 'hidden',
  },
  label: {
    ...theme.typography.body2,
    fontWeight: 'normal',
    color: theme.colors.titleColor,
  },
  value: {
    ...theme.typography.body2,
    fontWeight: 'normal',
    color: theme.colors.bodyColor,
  },
}));

const BasicDetail = ({ t, paymentPlan, property }) => {
  const classes = useStyles();
  const effectiveDate = useMemo(() => {
    const startDate = paymentPlan?.startDate
      ? moment(paymentPlan.startDate).format('YYYY-MM-DD HH:mm:ss')
      : '~';

    let endDate = '~';
    if (paymentPlan?.endDate) {
      const endDateFormate = moment(paymentPlan.endDate);
      endDate =
        endDateFormate.year() >= 9999
          ? t('landlord.payment.long_tail.open_end.field')
          : endDateFormate.format('YYYY-MM-DD HH:mm:ss');
    }

    if (paymentPlan && (paymentPlan.startDate || paymentPlan.endDate)) {
      return startDate.concat(' - ', endDate);
    }

    return '-';
  }, [paymentPlan]);

  return (
    <div className={classes.container}>
      <div className={classes.section}>
        <div className={classes.labelArea}>
          <span className={classes.label}>
            {t('landlord.payment.long_tail.payment_plan_name.field')}:
          </span>
        </div>
        <div className={classes.valueArea}>
          <span className={classes.value}>{paymentPlan?.name ?? '-'}</span>
        </div>
      </div>
      <div className={classes.section}>
        <div className={classes.labelArea}>
          <span className={classes.label}>
            {t('landlord.payment.long_tail.payment_currency.field')}:
          </span>
        </div>
        <div className={classes.valueArea}>
          <span className={classes.value}>{paymentPlan?.currency ?? '-'}</span>
        </div>
      </div>
      <div className={classes.section}>
        <div className={classes.labelArea}>
          <span className={classes.label}>
            {t('landlord.payment.long_tail.description.field')}:
          </span>
        </div>
        <div className={classes.valueArea}>
          <span className={classes.value}>{paymentPlan?.description ?? '-'}</span>
        </div>
      </div>
      <div className={classes.section}>
        <div className={classes.labelArea}>
          <span className={classes.label}>
            {t('landlord.payment.long_tail.effictive_date.field')}:
          </span>
        </div>
        <div className={classes.valueArea}>
          <span className={classes.value}>{effectiveDate}</span>
        </div>
      </div>
      <If condition={paymentPlan?.paymentOnline && property?.apCategory === 'KEY'}>
        <div className={classes.section}>
          <div className={classes.labelArea}>
            <span className={classes.label}>
              {t('landlord.payment.long_tail.initial_setup.label.student_must_pay')}:
            </span>
          </div>
          <div className={classes.valueArea}>
            <span className={classes.value}>
              {paymentPlan?.category === paymentPlanCategoryType.DEPOSIT_IS_REQUIRED
                ? t('landlord.payment.setup_status.deposit')
                : t('landlord.payment.setup_status.rent_payment')}
            </span>
          </div>
        </div>
      </If>
      <If condition={!paymentPlan?.paymentOnline}>
        <div className={classes.section}>
          <div className={classes.labelArea}>
            <span className={classes.label}>
              {t('landlord.payment.long_tail.student_must_payment.hint')}:
            </span>
          </div>
          <div className={classes.valueArea}>
            <span className={classes.value}>{t('landlord.booking.selected.button.no')}</span>
          </div>
        </div>
      </If>
    </div>
  );
};

export default BasicDetail;
